var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mh-100 h-100" }, [
    _c("div", { staticClass: "main-image-container" }, [
      _c("div", { staticClass: "secondary-nav justify-content-center" }, [
        _c("div", { staticClass: "align-items-center d-flex gap-10" }, [
          _c(
            "svg",
            {
              class: {
                "cursor-pointer": _vm.zoom > 0.5,
                disabled: _vm.zoom <= 0.5,
              },
              attrs: {
                opacity: _vm.zoom === 0.5 ? 0.5 : 1,
                width: "30",
                height: "30",
                viewBox: "0 0 30 30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.handleDecreaseZoom },
            },
            [
              _c("rect", {
                attrs: {
                  x: "0.5",
                  y: "0.5",
                  width: "29",
                  height: "29",
                  rx: "4.5",
                  fill: "#383838",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "0.5",
                  y: "0.5",
                  width: "29",
                  height: "29",
                  rx: "4.5",
                  stroke: "#595959",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M24.9001 13.65V16.35C24.9001 16.725 24.7688 17.0438 24.5063 17.3063C24.2438 17.5688 23.9251 17.7 23.5501 17.7H6.4501C6.0751 17.7 5.75635 17.5688 5.49385 17.3063C5.23135 17.0438 5.1001 16.725 5.1001 16.35V13.65C5.1001 13.275 5.23135 12.9563 5.49385 12.6938C5.75635 12.4313 6.0751 12.3 6.4501 12.3H23.5501C23.9251 12.3 24.2438 12.4313 24.5063 12.6938C24.7688 12.9563 24.9001 13.275 24.9001 13.65Z",
                  fill: "#E8EAED",
                },
              }),
            ]
          ),
          _vm._v(
            "\n\n                " +
              _vm._s(this.zoomLevel) +
              "\n                "
          ),
          _c(
            "svg",
            {
              class: {
                "cursor-pointer": _vm.zoom < 4,
                disabled: _vm.zoom >= 4,
              },
              attrs: {
                opacity: _vm.zoom === 4 ? 0.5 : 1,
                width: "30",
                height: "30",
                viewBox: "0 0 30 30",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.handleIncreaseZoom },
            },
            [
              _c("rect", {
                attrs: {
                  x: "0.5",
                  y: "0.5",
                  width: "29",
                  height: "29",
                  rx: "4.5",
                  fill: "#383838",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "0.5",
                  y: "0.5",
                  width: "29",
                  height: "29",
                  rx: "4.5",
                  stroke: "#595959",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M24 13.7727V16.2273C24 16.5682 23.8807 16.858 23.642 17.0966C23.4034 17.3352 23.1136 17.4545 22.7727 17.4545H17.4545V22.7727C17.4545 23.1136 17.3352 23.4034 17.0966 23.642C16.858 23.8807 16.5682 24 16.2273 24H13.7727C13.4318 24 13.142 23.8807 12.9034 23.642C12.6648 23.4034 12.5455 23.1136 12.5455 22.7727V17.4545H7.22727C6.88636 17.4545 6.59659 17.3352 6.35795 17.0966C6.11932 16.858 6 16.5682 6 16.2273V13.7727C6 13.4318 6.11932 13.142 6.35795 12.9034C6.59659 12.6648 6.88636 12.5455 7.22727 12.5455H12.5455V7.22727C12.5455 6.88636 12.6648 6.59659 12.9034 6.35795C13.142 6.11932 13.4318 6 13.7727 6H16.2273C16.5682 6 16.858 6.11932 17.0966 6.35795C17.3352 6.59659 17.4545 6.88636 17.4545 7.22727V12.5455H22.7727C23.1136 12.5455 23.4034 12.6648 23.642 12.9034C23.8807 13.142 24 13.4318 24 13.7727Z",
                  fill: "#E8EAED",
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.currentJob.state === "processing"
        ? _c("div", { staticClass: "mh-100 h-100" }, [
            _c("div", { staticClass: "gallery-1 overflow-hidden" }, [
              _c(
                "div",
                {
                  staticClass:
                    "gallery-row d-flex justify-content-center loading",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "image align-items-center justify-content-center",
                    },
                    [_c("img", { attrs: { src: _vm.loadingImage } })]
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentJob.state === "completed"
        ? _c("div", { staticClass: "mh-100 h-100" }, [
            _c("div", { staticClass: "gallery-1 overflow-hidden" }, [
              _c(
                "div",
                { staticClass: "gallery-row d-flex justify-content-center" },
                [
                  _c("canvas", {
                    ref: "canvas",
                    attrs: { id: "viewport" },
                    on: {
                      mousedown: _vm.onPointerDown,
                      touchstart: function ($event) {
                        return _vm.handleTouch($event, _vm.onPointerDown)
                      },
                      mouseup: _vm.onPointerUp,
                      touchend: function ($event) {
                        return _vm.handleTouch($event, _vm.onPointerUp)
                      },
                      mousemove: _vm.onPointerMove,
                      touchmove: function ($event) {
                        return _vm.handleTouch($event, _vm.onPointerMove)
                      },
                      wheel: function ($event) {
                        return _vm.handleZoom($event)
                      },
                      dblclick: _vm.handleZoomOnDbClick,
                    },
                  }),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }